<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="tableData.columns"
      border
      :height="height"
      :cell-style="tableData.cellStyle"
      :row-class-name="tableRowClassName"
      @row-dblclick="dblclick"
      @row-click="handleClick"
      @sort-change="sortChange"
      @selection-change="selectionchange"
      @cell-click="cellclick">
      <el-table-column v-if="tableData.isselection" type="selection" width="35">
      </el-table-column>
      <el-table-column v-if="tableData.isShowIndex" type="index" width="50">
      </el-table-column>
      <template v-for="(item, index) in tableData.fileds">
        <el-table-column
          v-if="
            item.filed !== 'opt'"
          :key="`${index}&`"
          :sortable="item.sortable"
          :show-overflow-tooltip="showTooltip"
          :prop="item.filed"
          :label="item.label"
          :width="item.width"
          :formatter="item.formatter">
        </el-table-column>
        <el-table-column
          v-if="item.filed === 'opt'"
          :key="`${index}&`"
          :fixed="'right'"
          :prop="item.filed"
          :label="item.label"
          :width="item.width">
          <template slot-scope="scope">
            <slot :scope="scope.row"></slot>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div v-if="pageFooter" class="pager">
      <el-pagination
        :current-page="pageNumber"
        :page-sizes="[20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    height: {
      type: [Number, String],
      default: 650
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    pageFooter: {
      type: Boolean,
      default: true
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    showNewIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectRowIndex: undefined,
      rowData: {}
    }
  },
  watch: {
    'tableData.fileds': {
      // eslint-disable-next-line no-unused-vars
      handler: function(fileds) {
        this.$nextTick(() => {
          if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
            this.$refs.multipleTable?.doLayout()
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.$refs.multipleTable?.doLayout()
    })
  },
  updated() {
    if (this.$refs.multipleTable && this.$refs.multipleTable?.doLayout) {
      this.$refs.multipleTable?.doLayout()
    }
    this.$nextTick(() => {
      this.$refs['multipleTable']?.doLayout()
    })
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.$message.success('复制成功')
        },
        () => {
          this.$message.error('复制失败，请手动复制')
        }
      )
    },
    selectAllRows() {
      // 选择所有行
      this.tableData.columns.forEach((row) => {
        this.$refs.multipleTable.toggleRowSelection(row, true)
      })
    },
    handleSizeChange(val) {
      console.log(val)
      this.$emit('handlePageChange', {
        pageNumber: this.pageNumber,
        pageSize: val
      })
    },
    handleCurrentChange(val) {
      console.log(this.pageSize)
      this.$emit('handlePageChange', {
        pageNumber: val,
        pageSize: this.pageSize
      })
    },
    cellclick(row, column) {
      this.$emit('cellclick', row, column)
    },
    dblclick(row) {
      this.$emit('dblclick', row)
    },
    handleClick(row) {
      const index = this.tableData.columns.findIndex((a) => {
        return a === row
      })
      this.selectRowIndex = index
      console.log(index)
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === this.selectRowIndex) {
        return 'select-row'
      }
      if (row.isEmergency) {
        return 'hurry-row'
      }
      return ''
    },
    sortChange({ column, prop, order }) {
      this.$emit('sortChange', { column, prop, order })
    },
    selectionchange(val) {
      this.$emit('selectionchange', val)
    }
  }
}
</script>
<style scoped>
/* 标签容器：控制整体位置 */
.tag-container {
  display: flex;
  gap: 4px; /* 标签间距 */
  margin-bottom: -2px; /* 和主文本留点空隙 */
  line-height: 1;
}

/* 统一标签基础样式 */
.status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 4px;
  font-size: 10px;
  font-weight: bold;
  color: white;
  border-radius: 4px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  min-width: 28px;
  height: 16px;
  box-sizing: border-box;
}

/* 催办单 - 红色 */
.status-tag.new {
  background-color: #e12d30;
}

/* 派送单 - 蓝色 */
.status-tag.delivery {
  background-color: #1391da;
}

.pager {
  text-align: right;
  margin-top: 5px;
}

.link-icon {
  display: inline-block;
  font-size: 1rem;
  margin-right: 5px;
  cursor: pointer;
  color: #007bff;
  /* 链接颜色 */
}

.copy-icon {
  cursor: pointer;
  margin-left: 10px;
  color: rgb(75, 118, 169);
}

/* .el-table /deep/ .cell {
  white-space: pre;
} */
</style>
